import React from 'react';
import scoreCard from '../assets/governance-score-card.jpg';
import gap from '../assets/screenshot-gap.jpg';
import roadmap from '../assets/screenshot-roadmap.jpg';
import actions from '../assets/screenshot-actions.jpg';

const HowItWorks = () => {
  const steps = [
    {
      title: 'Assess',
      description:
        'Evaluate governance effectiveness across key governance and board performance indicators.',
      img: scoreCard,
      caption: 'Governance score & findings',
    },
    {
      title: 'Identify',
      description: 'Reveal governance gaps, risks, weaknesses, and opportunities for improvement.',
      img: gap,
      caption: 'Gap analysis report',
    },
    {
      title: 'Prioritise',
      description:
        'Focus on the actions that will have the greatest impact on governance effectiveness.',
      img: roadmap,
      caption: 'Improvement roadmap',
    },
    {
      title: 'Improve',
      description: 'Implement a structured roadmap and track progress over time.',
      img: actions,
      caption: 'Action tracking dashboard',
    },
  ];

  return (
    <section id="how-it-works" className="py-24 md:py-32 px-6 max-w-7xl mx-auto border-t border-ink/5">
      <div className="max-w-3xl mx-auto text-center mb-20">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-ink leading-tight mb-6">
          Four steps to <span className="highlighter">better</span>{' '}
          governance.
        </h2>
        <p className="text-lg md:text-xl text-ink/60 leading-relaxed font-medium">
          Governance improvement shouldn't be complicated. It should be systematic — and you can see
          exactly what you get at every step.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
        {steps.map((step, i) => (
          <div
            key={i}
            className="flex flex-col h-full"
          >
            <div className="mb-6 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-ink text-lime flex items-center justify-center text-lg font-bold shadow-md">
                {i + 1}
              </div>
              <div>
                <h3 className="text-2xl font-bold text-ink">{step.title}</h3>
              </div>
            </div>
            <p className="text-ink/60 mb-8 leading-relaxed font-medium text-lg max-w-md">
              {step.description}
            </p>

            <figure className="mt-auto relative group">
              <div className="absolute -inset-2 bg-gradient-to-r from-lime/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-3xl blur-xl z-0"></div>
              <div className="rounded-2xl border border-ink/5 p-2 bg-white shadow-saas relative z-10 transform group-hover:-translate-y-1 transition-transform duration-300">
                <div className="overflow-hidden rounded-xl border border-ink/5 relative">
                  <img
                    src={step.img}
                    alt={step.caption}
                    loading="lazy"
                    draggable="false"
                    className="w-full h-64 lg:h-72 object-cover object-top block transform group-hover:scale-105 transition-transform duration-700 select-none"
                  />
                  <div className="absolute inset-0" aria-hidden="true"></div>
                </div>
              </div>
              <figcaption className="mt-4 text-xs font-bold uppercase tracking-[0.15em] text-ink/50 text-center">
                {step.caption}
              </figcaption>
            </figure>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
